export default __webpack_public_path__ + "static/media/safetynestLogo.4d07b5f9.png";